var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.rowsNeed),function(index){return _c('el-row',{key:index,attrs:{"gutter":5}},_vm._l((4),function(x){return _c('el-col',{key:x,attrs:{"xs":12,"sm":8,"md":8,"lg":6,"xl":6}},[(_vm.list[_vm.row(index - 1, x - 1)])?_c('AuditFileDetailCard',{attrs:{"record":_vm.list[_vm.row(index - 1, x - 1)]}}):_vm._e()],1)}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }